import { connect } from "react-redux";
import AboutNhogs from "../components/AboutNhogs";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(AboutNhogs);
